import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
const RegisterSuccess: React.FC = () => {
  return <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 max-w-md mx-auto text-center" data-id="element-214">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-215">
        <Check size={40} className="text-green-600" data-id="element-216" />
      </div>
      <h2 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-217">
        Registration Successful!
      </h2>
      <p className="text-navy-700 mb-8" data-id="element-218">
        Your account has been created and verified successfully. You can now log
        in to access your account.
      </p>
      <Link to="/auth/login" className="w-full bg-navy-900 hover:bg-navy-800 text-white py-3 rounded-md font-medium transition-colors inline-block" data-id="element-219">
        Log In to Your Account
      </Link>
      <div className="mt-6" data-id="element-220">
        <Link to="/" className="text-gold-500 hover:underline font-medium" data-id="element-221">
          Return to Homepage
        </Link>
      </div>
    </div>;
};
export default RegisterSuccess;